<template>
    <app-modal
        @close="$emit('close')"
        :ref="'modal'"
        @resize="resizeItem(item, $event)"
    >
        <template #header>
            <div :ref="'header'">
                <p
                    v-t="'Sessions.detail_player'"
                    class="
                        is-size-5
                        has-text-centered has-text-black
                        pt-2
                        mb-0
                        pb-1
                    "
                />
            </div>
        </template>
        <template #side-menu>
            <main class="menu">
                <div class="columns is-multiline is-centered mb-0">
                    <div class="column is-4 pb-1 pt-5">
                        <figure class="image is-48x48" style="margin: 0 auto">
                            <img class="is-rounded" :src="player.avatar" />
                        </figure>
                    </div>
                    <div class="column is-12 py-0">
                        <p
                            class="
                                is-size-5
                                has-text-centered has-text-weight-bold
                                is-uppercase
                            "
                        >
                            {{ player.alias ? player.alias : player.username }}
                        </p>
                    </div>
                </div>

                <hr class="navbar-divider has-background-grey-lighter" />

                <ul class="menu-list px-0">
                    <li
                        class="
                            has-text-weight-bold
                            is-size-6
                            mb-1
                            px-3
                            is-clickable
                        "
                    >
                        <a href="#general">{{ $t('Sessions.general_data') }}</a>
                    </li>
                    <li
                        v-if="player.clues.length"
                        class="
                            has-text-weight-bold
                            is-size-6
                            mb-1
                            px-3
                            is-clickable
                        "
                    >
                        <a href="#clue-detail">{{
                            $t('Sessions.clue_detail_data')
                        }}</a>
                    </li>
                    <li
                        class="
                            has-text-weight-bold
                            is-size-6
                            mb-1
                            px-3
                            is-clickable
                        "
                    >
                        <a href="#question-detail">{{
                            $t('Sessions.question_detail_data')
                        }}</a>
                    </li>
                </ul>

                <div class="px-4 py-4 has-text-centered">
                    <button
                        class="button is-primary is-fullsize"
                        @click="exportToPDF"
                        :class="{ 'is-loading disabled': showingProgress }"
                        v-t="!showingProgress ? 'Sessions.generate_pdf' : ''"
                    ></button>
                </div>
            </main>
        </template>
        <template #main-content>
            <div :ref="'content'" class="">
                <div :ref="'inner-content'" class="content">
                    <session-detail-player-general :player="player" />

                    <session-detail-player-clues
                        :player="player"
                        v-if="player.clues.length"
                    />

                    <session-detail-player-questions :player="player" />
                </div>
            </div>
            <VueHtml2pdf
                :show-layout="false"
                :float-layout="true"
                :enable-download="true"
                :preview-modal="false"
                :paginate-elements-by-height="1400"
                :pdf-content-width="'100%'"
                :filename="player.alias ? player.alias : player.username"
                :pdf-quality="2"
                :manual-pagination="false"
                pdf-format="a4"
                pdf-orientation="portrait"
                ref="html2Pdf"
                :htmlToPdfOptions="{
                    margin: 7,
                    jsPDF: {
                        orientation: 'portrait',
                        unit: 'mm',
                        format: 'a4',
                        putOnlyUsedFonts: 'false',
                        compress: 'false',
                        precision: '20',
                        filename: getFilename,
                    },
                }"
                @hasDownloaded="showProgress($event)"
            >
                <section slot="pdf-content">
                    <sessionDetailPlayerGeneralPDF
                        :player="player"
                        :report-info="reportInfo"
                    />
                    <sessionDetailPlayerCluesPDF
                        :player="player"
                        v-if="player.clues.length"
                    />
                    <sessionDetailPlayerQuestionsPDF :player="player" />
                </section>
            </VueHtml2pdf>
        </template>
    </app-modal>
</template>

<script>
import AppModal from '@/components/AppModal';
import SessionEndResumeBubble from '@/components/SessionEndResumeBubble';
import SessionDetailPlayerGeneral from '@/components/SessionDetailPlayerGeneral';
import SessionDetailPlayerClues from '@/components/SessionDetailPlayerClues';
import SessionDetailPlayerQuestions from '@/components/SessionDetailPlayerQuestions';
import SessionDetailPlayerGeneralPDF from '@/components/SessionDetailPlayerGeneralPDF';
import SessionDetailPlayerCluesPDF from '@/components/SessionDetailPlayerCluesPDF';
import SessionDetailPlayerQuestionsPDF from '@/components/SessionDetailPlayerQuestionsPDF';
import _ from 'underscore';
import { timeFormat } from '@/lib/helpers';
import VueHtml2pdf from 'vue-html2pdf';

export default {
    name: 'SessionDetailPlayer',
    components: {
        AppModal,
        SessionEndResumeBubble,
        VueHtml2pdf,
        SessionDetailPlayerGeneral,
        SessionDetailPlayerClues,
        SessionDetailPlayerQuestions,
        SessionDetailPlayerGeneralPDF,
        SessionDetailPlayerCluesPDF,
        SessionDetailPlayerQuestionsPDF,
    },
    props: {
        player: {
            type: Object,
            default: () => {
                return {};
            },
        },
        reportInfo: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return { showingProgress: false };
    },
    created() {
        window.addEventListener('resize', this.onResize);
    },
    mounted() {
        this.$refs['inner-content'].style.maxHeight =
            this.$refs.modal.$el.clientHeight - 100 + 'px';
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize);
    },
    computed: {
        getFilename() {
            return this.player.alias ? this.player.alias : this.player.username;
        },
    },
    methods: {
        onResize(e) {
            this.$refs['inner-content'].style.maxHeight =
                this.$refs.modal.$el.clientHeight - 100 + 'px';
        },
        exportToPDF() {
            this.showingProgress = true;
            this.$refs.html2Pdf.generatePdf();
        },
        showProgress(e) {
            this.showingProgress = false;
        },
    },
};
</script>

<style scoped>
.close {
    display: inline-block;
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 0;
    height: 20px;
    max-height: 20px;
    max-width: 20px;
    min-height: 20px;
    min-width: 20px;
    outline: none;
    position: relative;
    vertical-align: top;
    width: 20px;
}
.menu {
    overflow-x: hidden;
}
/deep/.bubble-container .title {
    color: #ffffff;
}
.table tr:not(.is-bordered-bottom) {
    border: none;
}
/deep/.modal-card-body.is-paddingless {
    overflow: hidden;
}
/deep/.lb-content {
    overflow: auto;
}
.content table td {
    border: none;
}

.content .table.is-vcentered td {
    vertical-align: middle;
}

.clue-detail-table tr:last-child {
    border-bottom: none;
}
/deep/.modal-card {
    width: 70%;
}

@media screen and (min-width: 1216px) {
    /deep/.lb-menu {
        width: 20%;
    }
}

#pdf /deep/.bubble-container .title {
    color: #ffffff;
    padding-bottom: 1.5rem;
}

#pdf .general-data,
#pdf .general-data tr,
#pdf .general-data td {
    border: 1px solid white;
}

#pdf .clue-table,
#pdf .clue-table tbody tr,
#pdf .clue-table tbody td {
    border: 1px solid white;
}

#pdf .helpers-table,
#pdf .helpers-table tbody tr,
#pdf .helpers-table tbody td {
    border: 1px solid white;
}

#pdf .question-table,
#pdf .question-table tbody,
#pdf .question-table thead,
#pdf .question-table tr,
#pdf .question-table td {
    border: 1px solid white;
}
.button.is-fullsize {
    width: 100%;
}
</style>
